<template>
  <div>
    <div v-if="groupChanges.length > 0" class="text-left">
      <div class="mb-3">
        Summary of {{ groupChanges.length }} group mapping
        {{ groupChanges.length === 1 ? 'change' : 'changes' }}:
      </div>
      <div class="generic-error-message">
        Warning: Saving will overwrite the original group mappings. Please review before proceeding
      </div>
      <v-alert
        v-if="yearCountReduced"
        color="#ff7f32"
        variant="outlined"
        density="compact"
        icon="mdi-alert"
        class="mb-2 mt-2"
      >
        <b>Notice</b>: Changing school type for year would cause the subjects/classes to lose their
        mapping as hierarchy has changed.
      </v-alert>
      <v-data-table
        :headers="groupChangeHeaders"
        :items="groupChanges"
        items-per-page="-1"
        hide-default-footer
      ></v-data-table>
    </div>

    <div v-if="overallChanges.length > 0" class="text-left">
      <div class="mb-3">Summary of group mapping changes from previous save result:</div>
      <v-data-table
        :headers="overallChangeHeaders"
        :items="overallChanges"
        items-per-page="-1"
        hide-default-footer
      ></v-data-table>
    </div>

    <student-group-sync-diff-alert
      v-if="studentGroupSyncDiffs.length > 0"
      :student-group-sync-diffs="studentGroupSyncDiffs"
      :display-ignore-message="true"
    />
  </div>
</template>

<script>
import StudentGroupSyncDiffAlert from './StudentGroupSyncDiffAlert';
import groupMappingChangeSummary from '@/lib/groupMappingChangeSummary';

export default {
  name: 'GroupMappingSummary',

  components: {
    StudentGroupSyncDiffAlert
  },

  props: {
    summary: { type: Object, default: null },
    studentGroupSyncDiffs: { type: Array, default: () => [] }
  },

  data() {
    return {
      groupChangeHeaders: [
        { title: 'Category', key: 'label', sortable: false },
        { title: 'Original (Total Count)', key: 'before', sortable: false },
        {
          title: 'Now (Total Count)',
          key: 'after',
          sortable: false,
          headerProps: { class: 'text-red font-weight-bold' },
          cellProps: { class: 'text-red font-weight-bold' }
        }
      ],
      overallChangeHeaders: [
        { title: 'Change Type', key: 'label', sortable: false },
        { title: 'Total Count', key: 'count', sortable: false }
      ]
    };
  },
  computed: {
    groupChanges() {
      const { groupChanges } = groupMappingChangeSummary.getGroupMappingChangeSummaryLines(
        this.summary
      );
      return groupChanges;
    },
    overallChanges() {
      const { overallChanges } = groupMappingChangeSummary.getGroupMappingChangeSummaryLines(
        this.summary
      );
      return overallChanges;
    },
    yearCountReduced() {
      return this.groupChanges.some((line) => line.label === 'Years');
    }
  }
};
</script>
